import React from 'react'
import styled from '@emotion/styled'
import { getThemeColor } from '@/utils/themes'
import { rem } from '@/utils/helpers'
import ThemeConsumer from '@/hoc/ThemeConsumer'
import Typography from '@/components/common/Typography'

const SectionHead = props => {
  const { theme, sub, main, lead, body, ...others } = props
  return (
    <Root {...others}>
      <Title>
        <Sub variant="caption" component="div" lang="en">{sub}</Sub>
        <Main theme={theme} variant="d2" component="div">{main}</Main>
      </Title>
      {lead && (
        <Lead variant="h1" component="h3">{lead}</Lead>
      )}
      {body && (
        <Body variant="body3">{body}</Body>
      )}
    </Root>
  )
}

export default ThemeConsumer(SectionHead)

const Root = styled.div`
  text-align: center;
`

const Title = styled.h2``

const Sub = styled(Typography)`
  position: relative;
  padding-bottom: ${rem(8)};

  &::after {
    content: '';
    display: block;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: ${rem(16)};
    height: 2px;
    background-color: currentColor;
  }
`

const Main = styled(Typography)`
  margin-top: ${rem(8)};

  strong {
    color: ${props => getThemeColor('primary', props.theme)}
  }
`

const Lead = styled(Typography)`
  margin-top: ${rem(40)};
`

const Body = styled(Typography)`
  margin-top: ${rem(16)};
  text-align: left;
`
